import {
  Container,
  CardContainer,
  CMdExpandMore,
  CardTitle,
  MedicalCard,
  MedicalSearch,
  MedicalTab,
  Table,
  PresGrid,
  PresForm,
} from "../../style/Prescription";
import UpArrow from "../../assets/AssetArrow.png";
import FormControl from "@material-ui/core/FormControl";
import { CustomDiv } from "../../style/shared";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { Button, ButtonGrey, CustomLinkButLink } from "../../style/Button";
import { FaRegEdit } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { Billing } from "../Billing/Billing";
import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import moment from "moment";
import "./select.css";
import "./Prescription.css";
import { subject } from "../../service";
import { verifyAuth } from "../../authverify";
import { ModalButton } from "../../style/ModalButton";
import TitlDollar from "../../assets/tiltdollar.png";
import TitlDollarGrey from "../../assets/dollargrey_tilt.png";
import { Image2 } from "../../style/Logo";
import styled from "styled-components";
import { CustomLinkBut } from "../../style/Dashboard";
import PrimeraCreative from "../NewCreatives/PrimeraCreative/PrimeraCreative";
import MedizenCreative from "../NewCreatives/MedizenCreative/MedizenCreative";
import { elementAt } from "rxjs";
import PrimeraVerticalAd from "../../assets/Ads/PrimeraV.jpg";
import MedizenVerticalAd from "../../assets/Ads/MedizenV.jpg";
import Horizontal from "../../assets/Ads/Horizontal.jpeg";
import { Grid } from "@material-ui/core";

const Card = (props) => {
  return (
    <CardContainer>
      <CardTitle>{props.name}</CardTitle>
      <CMdExpandMore size="25px" />
    </CardContainer>
  );
};
const Paper = styled.div`
  width: 100%;
  min-height: 45px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #c5c5c5;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 500;
`;
export class MedicationCard extends React.Component {
  constructor(props) {
    super(props);

    if (!verifyAuth()) {
      this.props.history.push({
        pathname: "/",
      });
    }

    this.state = {
      medicationName: "",
      amount: "",
      dosageForm: "",
      route: "",
      frequency: "",
      patientDirection: "",
      daysSupply: "",
      dispenseAmount: "",
      pharmacyNote: "",
      alternativeMedication: "",
      rows: [],
      medarray: [],
      imageHeader: "Ads/Horizontal2.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "",
    };
    //const { setBanner, setSelectedBanner } = this.props;

    let valuee = window.sessionStorage.getItem("keyselected");
    let p0 = new Map();
    p0.set("NA", {
      medicationName: "None",
      amount: "",
      dosageForm: "",
      route: "",
      frequency: "",
      patientDirection: "",
      daysSupply: "",
      dispenseAmount: "",
      pharmacyNote: "",
      alternativeMedication: "",
      imageHeader: "Ads/Horizontal2.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "",
    });

    let p1 = new Map();
    p1.set("NA", {
      medicationName: "None",
      amount: "",
      dosageForm: "",
      route: "",
      frequency: "",
      patientDirection: "",
      daysSupply: "",
      dispenseAmount: "",
      pharmacyNote: "",
      alternativeMedication: "",
      imageHeader: "Ads/Horizontal2.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "",
    });
    p1.set("mrbcmc", {
      medicationName: "Cyramza",
      amount: "10 mg/mL",
      dosageForm: "Injectible Vial",
      route: "IV",
      frequency: "Weekly",
      patientDirection: "To be administered at the Hospital",
      daysSupply: "7 Weeks - 7 Vials",
      dispenseAmount: "Vial",
      pharmacyNote: "DAW",
      alternativeMedication: "NA",
      imageHeader: "Ads/Horizontal3.jpeg",
      imageLeft: "Ads/Vertical1.jpeg",
      discount: false,
      price: "8.35",
    });
    p1.set("mdbtnc", {
      medicationName: "Taxotere",
      amount: "20 mg/mL",
      dosageForm: "Injectible Vial",
      route: "IV",
      frequency: "Once in 3 Weeks",
      patientDirection: "To be administered at the Hospital",
      daysSupply: "1 Vial",
      dispenseAmount: "Vial",
      pharmacyNote: "DAW",
      alternativeMedication: "NA",
      imageHeader: "Ads/Horizontal3.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "11.47",
    });

    let p2 = new Map();
    p2.set("NA", {
      medicationName: "None",
      amount: "",
      dosageForm: "",
      route: "",
      frequency: "",
      patientDirection: "",
      daysSupply: "",
      dispenseAmount: "",
      pharmacyNote: "",
      alternativeMedication: "",
      imageHeader: "Ads/Horizontal2.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "13.99",
    });
    p2.set("mfnc6", {
      medicationName: "Favipiravir",
      amount: "NA",
      dosageForm: "Tablets",
      route: "Oral",
      frequency:
        "Day 1 - 1000 mg twice a day (BID), Day 2 - 5 - 400 mg favipiravir twice a day (BID)",
      patientDirection:
        "Self-isolation. Continuous monitoring of Body Temp and SPO2. Follow-up after 5 days",
      daysSupply: "5",
      dispenseAmount: "Favipiravir 400 mg - 15 Tablets ",
      pharmacyNote: "NA",
      alternativeMedication: "NA",
      imageHeader: "Ads/Horizontal4.jpeg",
      imageLeft: "Ads/Vertical1.jpeg",
      discount: false,
      price: "7.29",
    });
    p2.set("mdbd6nc", {
      medicationName: "Decadron 6mg",
      amount: "NA",
      dosageForm: "Tablet",
      route: "Oral",
      frequency: "Once Daily (OD)",
      patientDirection:
        "Discontinue if your blood glucose levels are >300mg/dL, and see your Physician",
      daysSupply: "10",
      dispenseAmount: "Decadron 6 mg - 10 Tablets",
      pharmacyNote: "DAW",
      alternativeMedication: "NA",
      imageHeader: "Ads/Horizontal5.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "6.85",
    });

    let p3 = new Map();
    p3.set("NA", {
      medicationName: "None",
      amount: "",
      dosageForm: "",
      route: "",
      frequency: "",
      patientDirection: "",
      daysSupply: "",
      dispenseAmount: "",
      pharmacyNote: "",
      alternativeMedication: "",
      imageHeader: "Ads/Horizontal2.jpeg",
      // imageHeader: <PrimeraCreative />,
      imageLeft: "Ads/Vertical.jpeg",
      discount: false,
      price: "",
    });
    p3.set("mpbl5m", {
      medicationName: "Medizen",
      amount: "NA",
      dosageForm: "",
      route: "Tablet",
      frequency: "Twice a day",
      patientDirection: "1st dose upon waking up 2nd dose after 8 hours",
      daysSupply: "30",
      dispenseAmount: "50 Tablet",
      pharmacyNote: "60mg/day, 2 tab/day only",
      alternativeMedication: "Neurontin",
      imageHeader: "Ads/Horizontal1.jpeg",
      imageLeft: "Ads/Vertical1.jpeg",
      discount: true,
      price: "9.33",
    });
    p3.set("migblnc0", {
      medicationName: "Primera",
      amount: "NA",
      dosageForm: "Injection",
      route: "Infusion",
      frequency: "Once a week",
      patientDirection:
        "To be taken post-meal before sleeping. Keep hard candies handy",
      daysSupply: "",
      dispenseAmount: "10 injections",
      pharmacyNote:
        "2.5 mg once weekly for 4 weeks, Continue to 5mg once weekly for at least 4 weeks",
      alternativeMedication: "NA",
      imageHeader: "Ads/Horizontal5.jpeg",
      imageLeft: "Ads/Vertical.jpeg",
      discount: true,
      price: "8.78",
    });

    let cMap = new Map();
    cMap.set(0, p3);
    cMap.set(1, p3);
    cMap.set(2, p3);
    cMap.set(3, p3);
    cMap.set(4, p3);

    if (!valuee) valuee = 0;

    this.datasets = cMap.get(parseInt(valuee));

    this.sendMessage = this.sendMessage.bind(this);
    this.createRows = this.createRows.bind(this);
    this.restoreRows = this.restoreRows.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.renderview = this.renderview.bind(this);
    this.restoreRows();
    this.renderview();
  }

  handleChange = (event) => {
    if (event.target.value == "mpbl5m") {
      // this.props.setSelectedBanner(<PrimeraCreative />);
      this.props.setSelectedBanner(MedizenVerticalAd);
      window.sessionStorage.setItem("rValue", 1);
    } else if (event.target.value == "migblnc0") {
      this.props.setSelectedBanner(PrimeraVerticalAd);
      window.sessionStorage.setItem("rValue", 2);
    }

    let dataset = this.datasets.get(event.target.value);

    if (dataset) {
      this.state.medicationName = dataset.medicationName;
      this.state.amount = dataset.amount;
      this.state.dosageForm = dataset.dosageForm;
      this.state.route = dataset.route;
      this.state.frequency = dataset.frequency;
      this.state.patientDirection = dataset.patientDirection;
      this.state.daysSupply = dataset.daysSupply;
      this.state.dispenseAmount = dataset.dispenseAmount;
      this.state.pharmacyNote = dataset.pharmacyNote;
      this.state.alternativeMedication = dataset.alternativeMedication;
      this.state.imageHeader = dataset.imageHeader;
      this.state.imageLeft = dataset.imageLeft;
      this.state.discount = dataset.discount;
      this.state.price = dataset.price;
    }

    this.forceUpdate();
    this.props.onSubmitChild(this.state);
  };

  getMedKey = (item) => {
    if (!item || !item.medicationName) return null;
    return `${item.medicationName}|${item.amount || ""}|${item.dosageForm || ""}`;
  };

  saveMedarray = (medarray) => {
    try {
      window.sessionStorage.setItem("medarray", JSON.stringify(medarray));
    } catch (e) {
      // QuotaExceededError: keep a small deduped list so the app can recover
      const trimmed = medarray.slice(-10);
      try {
        window.sessionStorage.setItem("medarray", JSON.stringify(trimmed));
        this.state.medarray = trimmed;
      } catch (e2) {
        window.sessionStorage.removeItem("medarray");
        this.state.medarray = [];
      }
    }
  };

  dedupeMedarray = (list) => {
    const seen = new Set();
    return (list || []).filter((item) => {
      const key = this.getMedKey(item);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  renderview = () => {
    let rmedval = null;
    try {
      rmedval = JSON.parse(window.sessionStorage.getItem("med"));
    } catch (e) {
      window.sessionStorage.removeItem("med");
    }

    if (rmedval) {
      const alreadyExists = this.state.medarray.some(
        (item) => this.getMedKey(item) === this.getMedKey(rmedval)
      );
      if (!alreadyExists) {
        this.state.medarray.push(rmedval);
        this.saveMedarray(this.state.medarray);
      }
      window.sessionStorage.removeItem("med");
      this.sendMessage(rmedval);
    }

    if (this.state.medarray.length > 0) {
      this.state.medarray.forEach((element, index) => {
        this.createRows(element, index);
      });
    }
  };

  sendMessage = (val) => {
    let imagesel = {
      headerImg: val.imageHeader,
      leftImg: val.imageLeft,
      bottomImg: "",
    };

    subject.next(JSON.stringify(imagesel));
  };

  restoreRows() {
    let rowstring = window.sessionStorage.getItem("medarray");
    if (rowstring) {
      try {
        const parsed = JSON.parse(rowstring);
        // Drop corrupted entries (e.g. React row elements mistakenly saved)
        const cleaned = this.dedupeMedarray(
          (Array.isArray(parsed) ? parsed : []).filter(
            (item) => item && typeof item.medicationName === "string"
          )
        );
        this.state.medarray = cleaned;
        if (JSON.stringify(cleaned) !== rowstring) {
          this.saveMedarray(cleaned);
        }
      } catch (e) {
        window.sessionStorage.removeItem("medarray");
        this.state.medarray = [];
      }
    }
  }

  removeRow = (index) => {
    const newRows = this.state.rows.filter((row) => String(row.key) !== String(index));
    const newMedarray = this.state.medarray.filter((_, i) => i !== Number(index));
    this.setState({ rows: newRows, medarray: newMedarray });
    this.saveMedarray(newMedarray);
  };

  createRows = (valuem, index) => {
    var logotag = "";
    if (valuem.discount) {
      logotag = <Image2 src={TitlDollar} alt="logo" />;
    } else {
      logotag = <Image2 src={TitlDollarGrey} alt="logo" />;
    }

    this.state.rows.push(
      <React.Fragment key={index}>
        <tr>
          <td>{moment().format("DD-MMM-YYYY")}</td>
          <td style={{ color: "#4678ED", fontWeight: 500 }}>
            {valuem.medicationName} {logotag}
          </td>
          <td>{valuem.amount}</td>
          <td>0</td>
          <td>Pending</td>
          <td style={{ textAlign: "center" }}>
            <FaRegEdit color="#4678ED" />
          </td>
          <td style={{ textAlign: "center" }}>
            <ImCross onClick={() => this.removeRow(index)} />
          </td>
        </tr>
        <tr className="prescription-sig-row">
          <td></td>
          <td
            style={{ maxWidth: "200px", paddingLeft: "25px", color: "#969696" }}
          >
            <b
              style={{
                color: "#606060",
                fontWeight: 500,
                fontFamily: "work sans",
              }}
            >
              Sig:
            </b>{" "}
            {valuem.dosageForm} {valuem.route} {valuem.frequency} <br />
            <b
              style={{
                color: "#606060",
                fontWeight: 500,
                fontFamily: "work sans",
              }}
            >
              Sig:
            </b>{" "}
            {valuem.pharmacyNote} <br />
            QUES: 800-422-4523
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </React.Fragment>
    );
  };

  render() {

    return (
      <MedicalCard>
        <div>
          <CustomDiv color="#4678ED" fontWeight="600">
            <h1
              style={{
                fontSize: "18px",
                fontWeight: 600,
                fontFamily: "work sans",
                padding: "25px",
                paddingBottom: "0px",
              }}
            >
              Medical Search
            </h1>
          </CustomDiv>

          <MedicalSearch>
            <FormControl
              variant="outlined"
              style={{
                minWidth: "calc(100% - 120px)",
                maxHeight: "25px",
                marginTop: "10px",
                paddingBottom: "7px",
              }}
            >
              <Select
                className="select1"
                defaultValue={"NA"}
                name="presearch"
                onChange={this.handleChange}
                style={{
                  maxHeight: "25px",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "grey",
                  paddingBottom: "7px",
                }}
              >
                {[...this.datasets.keys()].map((keey) => (
                  <MenuItem value={keey} style={{ maxHeight: "25px" }}>
                    {this.datasets.get(keey).medicationName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              height="fit-content"
              backgroundColor="grey"
              marginL="15px"
              style={{
                padding: "5px 18px",
                height: "fit-content",
                borderRadius: "20px",
                marginTop: "3px",
                fontSize: "14px",
                backgroundImage: "none",
                backgroundColor: "#D0D2D3",
                color: "#606060",
                fontWeight: 600,
                maxWidth: "100px",
                fontFamily: "work sans",
              }}
            >
              Search
            </Button>
          </MedicalSearch>
        </div>
        <MedicalTab style={{ fontFamily: "work sans",fontSize: "14px",fontWeight: 500,color: "#312d2d", backgroundColor: "#ffff" }}>Pending Medication</MedicalTab>
        <div className="prescription-table-wrap">
          <Table className="prescription-table">
            <thead>
              <tr>
                <th>Date Created</th>
                <th>Medication</th>
                <th>Amount</th>
                <th>Refills</th>
                <th>Status</th>
                <th style={{ textAlign: "center" }}>Edit</th>
                <th style={{ textAlign: "center" }}>Remove</th>
              </tr>
            </thead>
            <tbody>
              {this.state.rows.map((name) => name)}
            </tbody>
          </Table>
        </div>
        <br />
      </MedicalCard>
    );
  }
}
export class Prescription extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    //const history = useHistory();
    this.state = { imgsrc: "Ads/Vertical.jpeg" };
    // this.handleOnClick = this.handleOnClick.bind(this);
    this.handleOnClickMed = this.handleOnClickMed.bind(this);

    let rmedval = JSON.parse(window.sessionStorage.getItem("med"));

    if (rmedval) this.state.imgsrc = rmedval.imageLeft;
  }
  logChildValue = (value) => {
    this.props.history.push({
      pathname: "/People/billing",
      state: value,
    });
  };

  handleOnClickMed = () => {
    this.props.history.push({
      pathname: "/People/Pharmacy",
      //state: value,
    });
  };
  render() {
    const { match, location, history } = this.props;
    const randValue = parseInt(window.sessionStorage.getItem("rValue"));
    return (
      <>
        <Container>
          <Grid container>
            <Grid item md={12} xs={12} lg={`${this.props.verticalCreative ? 9 : 12}`}>
              <Grid container>
                <Grid item md={3} xs={12}>
                  <Paper
                    style={{
                      color: "#4678ED",
                      fontWeight: 600,
                      fontSize: "18px",
                      fontFamily: "work sans",
                      maxWidth: "100%",
                      width: "100%",
                      padding: "0px 15px",
                    }}
                  >
                    New Medication{" "}
                    <img
                      src={UpArrow}
                      style={{
                        marginLeft: "auto",
                        marginTop: "0px",
                        width: "13.5px",
                      }}
                    />
                  </Paper>
                  <Paper
                    style={{
                      color: "#606060",
                      fontSize: "18px",
                      fontWeight: 600,
                      fontFamily: "work sans",
                      maxWidth: "100%",
                      width: "100%",
                      padding: "0px 15px",
                    }}
                  >
                    Medication history{" "}
                    <img
                      src={UpArrow}
                      style={{
                        marginLeft: "auto",
                        marginTop: "0px",
                        width: "13.5px",
                        transform: "rotate(180deg)",
                      }}
                    />
                  </Paper>
                  {
                    this.props.reactCreative &&
                    <div className="mobileCss mobCenter" >
                      <div className="responsiveMargin" style={{ maxWidth: '300px', minHeight: '250px',marginBottom: "20px"}}>
                        <iframe
                          title="iframe"
                          srcDoc={this.props.reactCreative}
                          style={{
                            width: '100%',
                            height: '100%',
                            maxWidth: '100%',
                            minHeight: '250px',
                            marginBottom: "30px"
                          }}
                          frameBorder="0"
                          scrolling="no"
                        />
                      </div>
                    </div>
                  }
                </Grid>
                <Grid item md={9} xs={12}>
                  <PresGrid>
                    <PresForm>
                      <MedicationCard
                        onSubmitChild={this.logChildValue}
                        history={history}
                        setBanner={this.props.selectedBanner}
                        setSelectedBanner={this.props.setSelectedBanner}
                      />
                      <div className="text-right" style={{ marginTop: "20px" }}>
                        <CustomLinkButLink
                          style={{ marginBottom: "20px", marginTop: "40px" }}
                          to="/People/Diagnosis"
                        >
                          Back
                        </CustomLinkButLink>
                        <CustomLinkButLink
                          primary
                          style={{ marginBottom: "20px", marginTop: "40px" }}
                          to="/People/Pharmacy"
                        >
                          Next
                        </CustomLinkButLink>
                      </div>
                    </PresForm>
                  </PresGrid>
                </Grid>
              </Grid>
            </Grid>
            {this.props.verticalCreative &&
              <Grid item lg={3} md={12} xs={12} className="text-right mobileCss mobCenter  d-flex justify-content-end">
                <div className='responsiveMargin'  style={{ maxWidth: '300px', minHeight: '600px', }}>
                  <iframe
                    title="iframe"
                    srcDoc={this.props.verticalCreative}
                    style={{
                      width: '100%',
                      height: '100%',
                      maxWidth: '100%',
                      minHeight: '600px',
                      marginBottom: "30px"
                    }}
                    frameBorder="0"
                    scrolling="no"
                  />
                </div>
              </Grid>
            }
          </Grid>

        </Container >
      </>
    );
  }
}
